export default __webpack_public_path__ + "static/media/2627 utensils side.e7c76a28.png";